import React, { HTMLInputTypeAttribute, JSX, useId } from "react"

import "./LexicalTextInput.less"

type Props = Readonly<{
  "data-test-id"?: string
  label: string
  onChange: (val: string) => void
  placeholder?: string
  value: string
  type?: HTMLInputTypeAttribute
}>

export default function LexicalTextInput({
  label,
  value,
  onChange,
  placeholder = "",
  "data-test-id": dataTestId,
  type = "text",
}: Props): JSX.Element {
  const inputId = useId()

  return (
    <div className="LexicalTextInput">
      <label htmlFor={inputId} className="LexicalTextInput__label">
        {label}
      </label>
      <input
        id={inputId}
        type={type}
        className="LexicalTextInput__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        data-test-id={dataTestId}
      />
    </div>
  )
}
